
export enum AgreementDetailsTabs {
    VIEW_AGREEMENT = "View Agreement",
    AMCILLARY_DOCUMENTS = "Ancillary Documents",
    AMENDMENTS = "Archived",
    RELATED_AGREEMENTS = "Related Agreements",
}